import React from "react";

const JobsTab = ({ jobs = [] }) => {
    return (
        <div className="tab-pane fade show active" role="tabpanel">
            <div className="tr-inner">
                <div className="trt-wraper">
                    <table className="table trucks-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Job ID</th>
                                <th>Job Description</th>
                                <th>Job Type</th>
                                <th className="align-text">Payment Type</th>
                                <th className="align-text">Pay Rate</th>
                                <th className="align-text">Job Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {jobs.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="text-center text-muted">
                                        No jobs found
                                    </td>
                                </tr>
                            ) : (
                                jobs.map((job, index) => (
                                    <tr key={job.job_name || index}>
                                        <td>{index + 1}</td>
                                        <td>{job.job_name}</td>
                                        <td>{job.job_description || "N/A"}</td>
                                        <td>{job.job_type || "N/A"}</td>
                                        <td className="align-text">{job.payment_type || "N/A"}</td>
                                        <td className="align-text">${job.payment_rate || "0.00"}</td>
                                        <td className="align-text">
                                            {job.job_amount ? `$${parseFloat(job.job_amount).toFixed(2)}` : "N/A"}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default JobsTab;